import Backbone from 'backbone';
import _ from 'underscore';

import {assert} from 'Asserts';
import Dispatcher, {FluxAction} from 'lib/Dispatcher';

import connectComponentToStore from './connectComponentToStore';

export const CHANGE_EVENT = 'change';

class Store implements Backbone.Events {
  static __STORES: Array<Store>;

  // We add these methods programmatically, so tell TypeScript to pretend that they exist.
  on!: Backbone.Events['on'];
  off!: Backbone.Events['off'];
  trigger!: Backbone.Events['trigger'];
  bind!: Backbone.Events['bind'];
  unbind!: Backbone.Events['unbind'];
  once!: Backbone.Events['once'];
  listenTo!: Backbone.Events['listenTo'];
  listenToOnce!: Backbone.Events['listenToOnce'];
  stopListening!: Backbone.Events['stopListening'];

  static initClass(): void {
    // Stores are registered to allow listener clean-up in tests. This technically prevents
    // proxyquired/stubStore stores from being garbage collected, but the memory usage should be negligible,
    // esp. since we remove listeners (see: test/lib/testSetup.ts)
    this.__STORES = [];
  }

  public dispatchIndex: string;

  constructor(dispatcher: typeof Dispatcher) {
    this.dispatchIndex = dispatcher.register((payload) => {
      assert(payload.actionType != null, 'Undefined payload action dispatched to store');
      return this.payloadHandler(payload);
    });
    this.resetState();
    Store.__STORES.push(this);
  }

  // TODO(TypeScript): Does this ever need to return anything? Seems like "void" may just work.
  __serverBootstrap(data: {}): {} | void {
    // eslint-disable-next-line no-restricted-syntax
    return _.extend(this, data);
  }

  payloadHandler(payload: FluxAction): boolean {
    throw new Error('payloadHandler has not been implemented');
  }

  resetState(): void {
    throw new Error('resetState has not been implemented');
  }

  connect<P extends {}, StoreProps extends {}>(
    mapStoreToProps: (store: Store, props: P) => StoreProps
  ): (component: React.ComponentType<P & StoreProps>) => React.ComponentClass<P> {
    return (component) => connectComponentToStore(this, mapStoreToProps, component);
  }

  emitChange(context?: Object): Store {
    return this.trigger(CHANGE_EVENT, context);
  }

  addChangeListener(callback: Function): Store {
    return this.on(CHANGE_EVENT, callback);
  }

  removeChangeListener(callback: Function): Store {
    if (callback == null) {
      throw new Error('Attempted to removeChangeListener with null callback');
    }
    return this.off(CHANGE_EVENT, callback);
  }
}
Store.initClass();

// eslint-disable-next-line no-restricted-syntax
_.extend(Store.prototype, Backbone.Events);

export default Store;
